import { useState } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import SearchFilters, { type SearchFilters as Filters } from './components/SearchFilters';
import OperationTable from './components/OperationTable';
import ReversalModal from './components/ReversalModal';
import { mockOperations } from './mockData';
import type { PointsOperation, ReversalFormData } from './types';

export default function PointsOperationsPage() {
  const [operations, setOperations] = useState<PointsOperation[]>(mockOperations);
  const [filteredOperations, setFilteredOperations] = useState<PointsOperation[]>(mockOperations);
  const [reversalOperation, setReversalOperation] = useState<PointsOperation | null>(null);

  const handleSearch = (filters: Filters) => {
    let filtered = [...operations];

    if (filters.transactionNo) {
      filtered = filtered.filter(op => op.transactionNo.includes(filters.transactionNo));
    }

    if (filters.tenantName) {
      filtered = filtered.filter(op => op.tenantName.includes(filters.tenantName));
    }

    if (filters.operationType !== 'all') {
      filtered = filtered.filter(op => op.operationType === filters.operationType);
    }

    if (filters.startTime) {
      const startTime = new Date(filters.startTime).getTime();
      filtered = filtered.filter(op => new Date(op.transactionTime).getTime() >= startTime);
    }

    if (filters.endTime) {
      const endTime = new Date(filters.endTime).getTime();
      filtered = filtered.filter(op => new Date(op.transactionTime).getTime() <= endTime);
    }

    setFilteredOperations(filtered);
  };

  const handleReversal = (data: ReversalFormData) => {
    if (!reversalOperation) return;

    const newOperation: PointsOperation = {
      id: `${operations.length + 1}`,
      transactionNo: `TXN${new Date().getTime()}`,
      operationType: 'reversal',
      transactionTime: new Date().toISOString().replace('T', ' ').substring(0, 19),
      tenantName: reversalOperation.tenantName,
      transactionAmount: -data.reversalAmount,
      operator: '当前用户',
      effectiveTime: reversalOperation.effectiveTime,
      expiryTime: reversalOperation.expiryTime,
      usagePeriod: reversalOperation.usagePeriod,
      originalTransactionNo: reversalOperation.transactionNo,
      deductedPoints: reversalOperation.deductedPoints,
      availablePoints: reversalOperation.availablePoints - data.reversalAmount,
      remainingPoints: reversalOperation.remainingPoints - data.reversalAmount,
      preConsumedPoints: reversalOperation.preConsumedPoints
    };

    setOperations([newOperation, ...operations]);
    setFilteredOperations([newOperation, ...filteredOperations]);
    setReversalOperation(null);
  };

  const handleExport = () => {
    alert('导出功能开发中...');
  };

  return (
    <MainLayout>
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-semibold text-gray-900">积分操作列表</h1>
          <div className="flex items-center gap-3">
            <button
              onClick={handleExport}
              className="px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-download-line mr-2"></i>
              导出
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/points/recharge')}
              className="px-4 py-2 bg-teal-600 text-white text-sm rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-add-line mr-2"></i>
              积分充值
            </button>
          </div>
        </div>

        <SearchFilters onSearch={handleSearch} />

        <OperationTable
          operations={filteredOperations}
          onReversal={setReversalOperation}
        />

        {reversalOperation && (
          <ReversalModal
            operation={reversalOperation}
            onClose={() => setReversalOperation(null)}
            onConfirm={handleReversal}
          />
        )}
      </div>
    </MainLayout>
  );
}
